import React from 'react';
import { connect } from 'react-redux';
import SelectionControl from 'react-md/lib/SelectionControls/SelectionControl';

import Icon from '__common/components/Icon';
import { isRmGridflex10D, isRmGridflex5Rwdi } from '__common/constants/products';
import { SELECT_BALLAST_RAIL_LENGTH } from 'actions';


type Props = {
  dispatch: Function,
  productId?: number,
  selection?: ballastRailSelection,
};

type GuideProps = {
  productId?: number,
  selectedLength?: number,
};

const BallastRailSelectionGuide = ({ productId, selectedLength }: GuideProps) => {
  let rule65;
  let rule81;
  if (isRmGridflex10D(productId)) {
    rule65 = 'Module length is 94″ or less';
    rule81 = 'Module length is greater than 94″';
  } else if (isRmGridflex5Rwdi(productId)) {
    rule65 = 'Ballast blocks per module: 4 or fewer';
    rule81 = 'Ballast blocks per module: more than 4';
  }

  if (!rule65 || !rule81) {
    return null;
  }

  return (
    <aside
      className="ballast-rail-selection-guide"
      role="note"
      aria-label="Ballast rail selection guide"
    >
      <div className="ballast-rail-selection-guide__heading">
        <Icon>info_outline</Icon>
        <span>Selection guide</span>
      </div>
      <div
        className={`ballast-rail-selection-guide__rule${
          selectedLength === 65 ? ' ballast-rail-selection-guide__rule--active' : ''
        }`}
        aria-current={selectedLength === 65 ? 'true' : undefined}
      >
        <span className="ballast-rail-selection-guide__badge">65″</span>
        <span className="ballast-rail-selection-guide__criteria">{rule65}</span>
      </div>
      <div
        className={`ballast-rail-selection-guide__rule${
          selectedLength === 81 ? ' ballast-rail-selection-guide__rule--active' : ''
        }`}
        aria-current={selectedLength === 81 ? 'true' : undefined}
      >
        <span className="ballast-rail-selection-guide__badge">81″</span>
        <span className="ballast-rail-selection-guide__criteria">{rule81}</span>
      </div>
      <p className="ballast-rail-selection-guide__scope">
        Selection applies to the entire project.
      </p>
    </aside>
  );
};

class BallastRailSelector extends React.Component<Props> {
  onSelected = (length: number, checked: boolean) => {
    if (checked) {
      this.props.dispatch(SELECT_BALLAST_RAIL_LENGTH(length));
    }
  }

  render() {
    const { productId, selection } = this.props;
    if (!selection || !selection.editable || !selection.options) {
      return null;
    }

    return (
      <div>
        <div className="control-panel-label bom-sidebar-main-header">
          Select Ballast Rail
        </div>
        <div className="rail-lists ballast-rail-list">
          {selection.options.map(option => (
            <SelectionControl
              key={option.length}
              id={`ballast-rail-${option.length}`}
              name="ballast-rail-length"
              label={option.label}
              type="radio"
              value={option.length}
              inline={true}
              checked={selection.selected_length === option.length}
              disabled={option.disabled}
              className={option.disabled ? 'ballast-rail-option--disabled' : ''}
              onChange={this.onSelected.bind(null, option.length)}
              checkedRadioIcon={(<Icon>check</Icon>)}
              uncheckedRadioIcon={(<Icon>check</Icon>)}
            />
          ))}
        </div>
        <BallastRailSelectionGuide
          productId={productId}
          selectedLength={selection.selected_length}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: appState) => ({
  selection: state.bom.extraParameters.ballast_rail_selection,
});

export default connect(mapStateToProps)(BallastRailSelector);
